export default "__VITE_ASSET__zGh9DKq9__"